import React, { Suspense, lazy, useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch, Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser'; 
import Notifications, {notify} from 'react-notify-toast';
import logo from './logo.svg';
import "./components/Global.scss";
import UserContext from './components/user/UserContext';

import Loading from "./assets/loading.gif";

const MyTrips = lazy(() => import('./pages/MyTrips'));
const MapContainer = lazy(() => import('./pages/Map'));
const Trip = lazy(() => import('./pages/Trip'));
const SignIn = lazy(() => import('./pages/SignIn'));



function App(props) {
	const [siteHeader, setSiteHeader] = useState(0);


	useEffect(() => {
		// const user = localStorage.getItem('trip-user');
		// if (user) {
		// 	setUser(user);
		// } else {
		// 	//Router.push('/signin');
		// 	//props.history.push("/signin"); 
		// }
		getHeader();
	}, []);

	const getHeader = () => {
		fetch('/explore-nova-scotia-wineries/trip-planner/').then(function (response) {
			// The API call was successful!
			return response.text();
		}).then(function (html) {
		
			// Convert the HTML string into a document object
			var parser = new DOMParser();
			var doc = parser.parseFromString(html, 'text/html');
			const topbar = doc.querySelector('.site-header');

			const hero = doc.querySelector('.hero-section');
			
			//const myCSS3 = doc.querySelector('#studio-pro-css');
			const myCSS = doc.querySelector('#wp-custom-css');
			const myCSS2 = doc.querySelector('#studio-pro-inline-css');
			
			console.log('html, ', myCSS);
			setSiteHeader(topbar.outerHTML  + hero.outerHTML + myCSS.outerHTML + myCSS2.outerHTML);
		}).catch(function (err) {
			// There was an error
			console.warn('Something went wrong.', err);
		});
		// console.log("loadss");
	}

	return (
		<div className="App">
			<div id="tpbr_topbar"><div id="tpbr_box"><a align="right" href="https://winesofnovascotia.ca/industry">Industry</a> | <a href="https://winesofnovascotia.ca/category/media/">Media</a> | <a href="https://winesofnovascotia.ca/category/blog/">Blog</a> | <a href="https://winesofnovascotia.ca/login">Login</a></div></div>
			{ ReactHtmlParser(siteHeader)}
			{/* <UserContext.Provider value={{ user: user, setUser: setUser }}> */}
			<div className="my_container_out">
			<div className="my_container trip_app">
			<Router  basename={'/trip'}>
						<Suspense fallback={(
						<div className="isLoading">
							<img src={Loading} />
						</div>
						)}>

					<Switch>
						<Route exact path="/" component={MapContainer} />
						<Route path="/my-trips" component={MyTrips} />
						<Route path="/map" component={MapContainer} />
						<Route path="/signin" component={SignIn} />
						<Route path="/trip/:id/:action" component={Trip} />
					</Switch>
				</Suspense>
			</Router>
			</div></div>
				{/* </UserContext.Provider> */}
			<Notifications />
		</div>
	);
}

export default App;
